import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const AccountActionsToggle = ({ account, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(account.active ? 'actions.deactivate' : 'actions.activate')}
    color={account.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={account.isLoading}
    onClick={(e) => {
      e.preventDefault();
      handleClick(account.id);
    }}
  />
);

export default translate()(AccountActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/actions/AccountsActionsToggle.js